"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as e } from "react";
import h from "../components/Icon/SvgIcon.js";
const l = (o) => /* @__PURE__ */ a(
  h,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.497 4.497a2.125 2.125 0 0 1 3.534.878h9.219a.625.625 0 1 1 0 1.25h-9.219a2.125 2.125 0 0 1-4.062 0H3.75a.625.625 0 1 1 0-1.25h3.219c.101-.328.281-.63.528-.878M9 5.125a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75m4.497 5.372a2.125 2.125 0 0 1 3.534.878h3.219a.625.625 0 1 1 0 1.25h-3.219a2.124 2.124 0 0 1-4.062 0H3.75a.625.625 0 1 1 0-1.25h9.219c.101-.328.281-.63.528-.878m1.503.628a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75m-7.503 5.372a2.125 2.125 0 0 1 3.534.878h9.219a.625.625 0 1 1 0 1.25h-9.219a2.124 2.124 0 0 1-4.062 0H3.75a.625.625 0 1 1 0-1.25h3.219c.101-.328.281-.63.528-.878M9 17.125a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75",
        clipRule: "evenodd"
      }
    )
  }
), i = e(l);
export {
  i as Filter,
  i as default
};
